import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import search from './searchReducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
const store = createStore(search, composeEnhancers(applyMiddleware(thunk)));

export default store;
